module.exports = __webpack_public_path__ + "static/media/181IT251.812f2b20.jpg";